import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";

import AirConditioning from "../../images/HeroBanners/AirConditioning.jpg";

import HorizontalIcons from "../../components/horizontal-icons";
import GradientHero from "../../components/gradientHero";
import Layout from "../../components/layout";

const ServiceAndMaintenance = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "commercial/air-conditioning", idType: URI) {
          commercialAirConditioning {
            acoItems {
              content
              heading
              image {
                altText
                sourceUrl
              }
            }
            acoLink {
              url
              target
              title
            }
            csHeader
            csRepeater {
              toggle
              content
              header
              image {
                altText
                sourceUrl
              }
            }
            ctaHeader
            ctaLink {
              target
              title
              url
            }
            featuresItems {
              heading
              image {
                sourceUrl
              }
            }
            heroBackgroundColor
            heroContent
            heroHeading
            heroImage {
              altText
              sourceUrl
            }
            heroLink {
              target
              title
              url
            }
            summaryContent
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.commercialAirConditioning || {};
  return (
    <Layout pageContext={pageContext}>
      <GradientHero image={data?.heroImage?.sourceUrl}>
        <h5>{data?.heroHeading}</h5>

        <p>{data?.heroContent}</p>
        <a href={data?.heroLink?.url}>{data?.heroLink?.title}</a>
      </GradientHero>

      <div className="bg-black">
        <div className="max-w-6xl text-center mx-5 md:mx-20 lg:mx-auto py-20">
          <p
            className="text-xl text-white mb-10"
            dangerouslySetInnerHTML={{ __html: data?.summaryContent }}
          ></p>
        </div>
      </div>

      <div className="text-center mb-28 content-section">
        <ul className=" gap-y-20 text-left pt-28 pb-24 flex flex-wrap grid grid-cols-1 lg:grid-cols-2 gap-x-20 max-w-7xl mx-10 sm:mx-auto">
          {data?.acoItems?.map((v, i) => (
            <li key={i} className="grid grid-cols-1 sm:grid-cols-6 ">
              <div className="col-span-1 mt-0.5">
                <img
                  className="sm:w-full sm:mb-0 mb-5"
                  src={v?.image?.sourceUrl}
                  width="75.74"
                  height="56.381"
                />
              </div>
              <div className="col-span-5">
                <h3 className="text-4xl text-black mb-2">{v?.heading}</h3>
                <div
                  className="commercial-content text-xl leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: v?.content }}
                ></div>
              </div>
            </li>
          ))}
        </ul>
        <a
          className="bg-tan text-3xl text-black uppercase font-anton px-12 py-2"
          href={data?.acoLink?.url}
          target={data?.acoLink?.target}
        >
          {data?.acoLink?.title}
        </a>
      </div>

      <div style={{ backgroundColor: "#F8F8F8" }}>
        <HorizontalIcons
          icons={data?.featuresItems?.map((v, i) => ({
            text: v?.heading,
            image: v?.image?.sourceUrl,
          }))}
        />

        <div className="max-w-7xl text-center mx-auto pt-3 pb-32">
          <h3 className="text-black text-center text-3xl mb-10">
            {data?.ctaHeader}
          </h3>
          <a
            className="mt-30 bg-tan text-2xl text-black uppercase font-anton px-16 py-3"
            href={data?.ctaLink?.url}
            target={data?.ctaLink?.target}
          >
            {data?.ctaLink?.title}
          </a>
        </div>
      </div>

      {!!data?.csRepeater?.filter((x) => x?.toggle)?.length && (
        <div className="mb-24 case-studies">
          <h3 className="text-black text-4xl text-center my-16">
            {data?.csHeader}
          </h3>
          {data?.csRepeater
            ?.filter((x) => x?.toggle)
            .map((v, i) => (
              <div className="flex flex-wrap lg:flex-nowrap max-w-6xl mx-5 md:mx-20 lg:mx-auto mb-10">
                <div className="w-full lg:w-1/2 ">
                  <div
                    className="h-80 bg-tan bg-img"
                    style={{ backgroundImage: `url(${v?.image?.sourceUrl})` }}
                  ></div>
                </div>
                <div className="ml-5 w-full lg:w-1/2">
                  <h3 className="text-black text-xl">{v?.header}</h3>
                  <p>{v?.content}</p>
                </div>
              </div>
            ))}
        </div>
      )}
    </Layout>
  );
};

export default ServiceAndMaintenance;
